/*
    Критическое уведомление об ошибке. Отображается всегда в пределах текущей видимой области,
    сейчас снизу экрана. Так же смотри messages.js

       Сообщение выраженно следующим образом:
       {
            code: Number,
            message: String
       }

       Пример подключения в main.js:

       import alert from '@/util/global-alert.js'
       Vue.prototype.$alert = alert
 */

import Vue from 'vue'
import GlobalAlert from "@/components/GlobalAlert.vue";
import { RequestError } from '@/plugins/request'

class GlobalApplicationAlert {

    constructor(){
        var ComponentClass = Vue.extend(GlobalAlert)
        this.componentInstance = new ComponentClass()
        this.componentInstance.$mount() // pass nothing
    }

    show(error_or_message){
        if (error_or_message instanceof RequestError) {
            this.componentInstance.$props.message = '[' + error_or_message.code + '] ' + error_or_message.message
        } else {
            this.componentInstance.$props.message = error_or_message;
        }       
        this.componentInstance.show();
    }

    hide(){
        this.componentInstance.hide();
    }
}

const alert = new GlobalApplicationAlert();
Object.freeze(alert);

export default alert;